import { render } from "./PerfilSalud.vue?vue&type=template&id=9222ce1e"
import script from "./PerfilSalud.vue?vue&type=script&lang=js"
export * from "./PerfilSalud.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__